import { render, staticRenderFns } from "./addVenues.vue?vue&type=template&id=84e8a962&scoped=true&"
import script from "./addVenues.vue?vue&type=script&lang=js&"
export * from "./addVenues.vue?vue&type=script&lang=js&"
import style0 from "./addVenues.vue?vue&type=style&index=0&id=84e8a962&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84e8a962",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\atmolab_server_manage\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('84e8a962')) {
      api.createRecord('84e8a962', component.options)
    } else {
      api.reload('84e8a962', component.options)
    }
    module.hot.accept("./addVenues.vue?vue&type=template&id=84e8a962&scoped=true&", function () {
      api.rerender('84e8a962', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/teammanagemant/venuesList/component/addVenues.vue"
export default component.exports